import { createBrowserHistory } from 'history';

export const url = 'https://www.hamrahac.com';
 //export const url = 'http://127.0.0.1:8000';
//  export const url = 'http://192.168.249.193:8000';

export const toastConfig = {
    position: 'top-left',
    //autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
};
export const latinAlphabet = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
export const alphabet = ['الف', 'ب', 'پ', 'ت', 'ث', 'ج', 'چ', 'ه', 'خ', 'د', 'ذ', 'ر', 'ز', 'ژ', 'س', 'ش', 'ص', 'ض', 'ط', 'ظ', 'ع', 'غ', 'ف', 'ق', 'ک', 'گ', 'ل', 'م', 'ن', 'و', 'ه', 'ی'];
// export const licenseTypes = ['پایه یک', 'پایه دو', 'پایه سه', 'موتور سیکلت', 'ویژه', 'بین المللی', 'فاقد گواهینامه', 'سایر'];
export const licenseTypes = ['First grade','Second grade','Third grade','Motor','Specific','International','License less','Etcetra']
// export const damagedPositions = ['جلو', 'عقب', 'پهلوی چپ', 'پهلوی راست', 'جلو راست', 'جلو چپ', 'عقب راست', 'عقب چپ', 'سقف'];
export const damagedPositions = ['Ceiling', 'Back left', 'Back right', 'Left side', 'Right side', 'Front right', 'Front left', 'Back', 'Front'];
// export const cabinTypes = ['میکرو', 'سدان', 'هاچبک', 'کوپه', 'استیشن', 'رودستر', 'کابریولت', 'ماسل', 'اسپرت', 'مسابقه ای', 'لیموزین', 'کراس', 'پیکاپ', 'شاسی بلند', 'مینی ون', 'کمپر', 'اتوبوس', 'مینی تراک', 'کامیون', 'کامیون سنگین'];
export const cabinTypes = ['Micro', 'Sedan', 'HBack', 'Coupe', 'Station', 'Roadster', 'Cabriolet', 'Musel', 'Sport', 'Racer', 'Limo', 'Cross', 'Pickup', 'SUV', 'Mini van', 'Camper', 'Bus', 'Mini truck', 'Truck', 'heavy truck'];
// export const terms = ['آ','ا','ء','أ','إ','ؤ','ۀ','ة','ي','ژ','َ','ُ','ِ','ّ','ئ','ٌ', 'ب', 'پ', 'ت', 'ث', 'ج', 'چ','ح' ,'ه', 'خ', 'د', 'ذ', 'ر', 'ز', 'ژ', 'س', 'ش', 'ص', 'ض', 'ط', 'ظ', 'ع', 'غ', 'ف', 'ق', 'ک', 'گ', 'ل', 'م', 'ن', 'و', 'ه', 'ی']
export const months = [
    {value:1,label :'فروردین'},
    {value:2,label:'اردیبهشت'},
    {value:3,label:'خرداد'},
    {value:4,label:'تیر'},
    {value:5,label:'مرداد'},
    {value:6,label:'شهریور'},
    {value:7,label:'مهر'},
    {value:8,label:'آبان'},
    {value:9,label:'آذر'},
    {value:10,label:'دی'},
    {value:11,label:'بهمن'},
    {value:12,label:'اسفند'}]

export const history = createBrowserHistory();
